var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-button-wrapper"},[_c('div',{staticClass:"base-button",class:[
            _vm.disabled ? 'disabled' : 'active',
            _vm.pressed ? 'pressed' : '',
        ],on:{"click":_vm.handleClick}},[_c('p',{staticClass:"base-button-text"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }